export default "__VITE_ASSET__34d4193a__"